










































































import { Component, Vue } from 'vue-property-decorator';
import { InvoicesApi } from '../api/invoices';
import { ElTable } from 'element-ui/types/table';
import { PaymentVm } from '../classes/paymentVm';
import { PaymentHistoryVm } from '../classes/paymentHistoryVm';
import moment, { Moment } from 'moment';

@Component
export default class List extends Vue {
  public paymentHistColumns: any[] = [];
  public paymentHistData: PaymentHistoryVm = {
    payments: [],
    totalCount: 0,
  };
  public paymentHistLoading: boolean = false;
  public loading: boolean = false;
  public pageNumber: number = 1;
  public pageSize: number = 25;
  public isDescending: boolean = true;
  public orderBy: string = 'Date';
  private api: InvoicesApi;

  constructor() {
    super();
    this.api = new InvoicesApi();
  }

  public async created() {
    this.paymentHistColumns = [
      {
        prop: 'date',
        label: this.$t('invoices.date'),
        sortable: 'custom',
      },
      {
        prop: 'subscriptionCode',
        label: this.$t('invoices.subscriptionCode'),
        sortable: false,
      },
      {
        prop: 'amount',
        label: this.$t('invoices.amount'),
        sortable: 'custom',
      },
      {
        prop: 'status',
        label: this.$t('invoices.status'),
        sortable: 'custom',
      },
      {
        prop: 'invoicePdf',
        label: this.$t('invoices.invoicePdf'),
        sortable: false,
      },
    ];

    this.refreshPaymentHis();
  }

  public async refreshPaymentHis() {
    this.paymentHistLoading = true;
    try {
      this.paymentHistData = await this.api.getPaymentsHistory(
        this.pageNumber,
        this.pageSize,
        this.isDescending,
        this.orderBy,
      );
    } catch (error) {
      console.error(error);
    }
    this.paymentHistLoading = false;
  }

  public changePaymentHisPageSize(val: number) {
    this.pageSize = val;
    this.refreshPaymentHis();
  }

  public setSortPaymentHist(val: any) {
    if (val.order === null) {
      this.orderBy = val.prop;
      this.isDescending = false;
      (this.$refs.paymentHistTable as Vue & { sort: (prop: string, sort: string) => {}})
      .sort(val.prop, 'ascending');
    } else {
      this.orderBy = val.prop.charAt(0).toUpperCase() + val.prop.slice(1);
      val.order === 'ascending' ? this.isDescending = false : this.isDescending = true;
    }

    this.refreshPaymentHis();
  }

  public formatDateTime(textDate: string) {
    const date = moment(textDate);
    return date.format('DD/MM/YYYY HH:mm');
  }

  public formatAmount(amount: number) {
    const str = String(amount).substr(0, String(amount).length - 2);
    return str + ',00 EUR';
  }
}
